// @generated by protoc-gen-es v1.10.0
// @generated from file penumbra/core/keys/v1/keys.proto (package penumbra.core.keys.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * A Penumbra address. An address in Penumbra is a Bech32m-encoded
 * string, with the human-readable prefix (HRP) `penumbrav2t`.
 *
 * @generated from message penumbra.core.keys.v1.Address
 */
export const Address = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.keys.v1.Address",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "alt_bech32m", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message penumbra.core.keys.v1.AddressView
 */
export const AddressView = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.keys.v1.AddressView",
  () => [
    { no: 1, name: "decoded", kind: "message", T: AddressView_Decoded, oneof: "address_view" },
    { no: 2, name: "opaque", kind: "message", T: AddressView_Opaque, oneof: "address_view" },
  ],
);

/**
 * A decoded address, with information about the address index and wallet ID visible.
 *
 * @generated from message penumbra.core.keys.v1.AddressView.Decoded
 */
export const AddressView_Decoded = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.keys.v1.AddressView.Decoded",
  () => [
    { no: 1, name: "address", kind: "message", T: Address },
    { no: 2, name: "index", kind: "message", T: AddressIndex },
    { no: 3, name: "wallet_id", kind: "message", T: WalletId },
  ],
  {localName: "AddressView_Decoded"},
);

/**
 * An opaque address, with no information about the address index or wallet ID visible.
 *
 * @generated from message penumbra.core.keys.v1.AddressView.Opaque
 */
export const AddressView_Opaque = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.keys.v1.AddressView.Opaque",
  () => [
    { no: 1, name: "address", kind: "message", T: Address },
  ],
  {localName: "AddressView_Opaque"},
);

/**
 * @generated from message penumbra.core.keys.v1.PayloadKey
 */
export const PayloadKey = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.keys.v1.PayloadKey",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * @generated from message penumbra.core.keys.v1.SpendKey
 */
export const SpendKey = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.keys.v1.SpendKey",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * @generated from message penumbra.core.keys.v1.FullViewingKey
 */
export const FullViewingKey = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.keys.v1.FullViewingKey",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * @generated from message penumbra.core.keys.v1.WalletId
 */
export const WalletId = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.keys.v1.WalletId",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * @generated from message penumbra.core.keys.v1.Diversifier
 */
export const Diversifier = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.keys.v1.Diversifier",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * @generated from message penumbra.core.keys.v1.AddressIndex
 */
export const AddressIndex = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.keys.v1.AddressIndex",
  () => [
    { no: 2, name: "account", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "randomizer", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * A validator's identity key (decaf377-rdsa spendauth verification key).
 *
 * @generated from message penumbra.core.keys.v1.IdentityKey
 */
export const IdentityKey = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.keys.v1.IdentityKey",
  () => [
    { no: 1, name: "ik", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * A validator's governance key (decaf377-rdsa spendauth verification key).
 *
 * @generated from message penumbra.core.keys.v1.GovernanceKey
 */
export const GovernanceKey = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.keys.v1.GovernanceKey",
  () => [
    { no: 1, name: "gk", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * @generated from message penumbra.core.keys.v1.ConsensusKey
 */
export const ConsensusKey = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.keys.v1.ConsensusKey",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

